import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default function data(apiData = [], onEdit, onApprove, onCancel) {
  return {
    columns: [
      { Header: "Community Name", accessor: "communityname", align: "left" },
      { Header: "Customer Name", accessor: "title", align: "left" },
      { Header: "Email", accessor: "Email", align: "left" },
      { Header: "Mobile Number", accessor: "mobileNumber", align: "center" },
      { Header: "No Of Inventory", accessor: "bookingCount", align: "center" },
      { Header: "Broker Id", accessor: "brokerId", align: "center" },
      { Header: "Broker Name", accessor: "brokerName", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },

      { Header: "Action", accessor: "action", align: "center" },
    ],

    rows: apiData.map((item) => ({
      communityname: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.communityname ?? "-"}
        </MDTypography>
      ),
      title: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {item.customerName ?? "-"}
        </MDTypography>
      ),
      Email: (
        <MDTypography variant="caption" color="text">
          {item.customerEmail ?? "-"}
        </MDTypography>
      ),
      mobileNumber: (
        <MDTypography variant="caption" color="text">
          {item.mobileNumber ?? "-"}
        </MDTypography>
      ),
      bookingCount: (
        <MDTypography variant="caption" color="text">
          {item.bookingCount ?? "-"}
        </MDTypography>
      ),
      brokerId: (
        <MDTypography variant="caption" color="text">
          {item.brokerId ?? "-"}
        </MDTypography>
      ),
      brokerName: (
        <MDTypography variant="caption" color="text">
          {item.brokerName ?? "-"}
        </MDTypography>
      ),
      status: (
        <MDTypography
          variant="caption"
          sx={{
            color:
              item?.approve == 1
                ? "green"
                : item?.cancel == 1
                ? "red"
                : item?.cancel == 0 && item?.approve == 0
                ? "orange"
                : "text.primary",
            fontWeight: "medium",
          }}
        >
          {item?.cancel == 0 && item?.approve == 0
            ? "Pending"
            : item?.approve == 1
            ? "Approve"
            : item?.cancel == 1
            ? "Cancel"
            : "-"}
        </MDTypography>
      ),

      action: (
        <MDBox display="flex" gap={1} justifyContent="center">
          <MDButton
            variant="contained"
            color="success"
            size="small"
            sx={{
              padding: "6px 12px",
              borderRadius: "8px",
              fontWeight: "bold",
              fontSize: "0.8rem",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#2e7d32",
                transform: "scale(1.05)",
              },
            }}
            disabled={item?.approve == 1 || item.cancel == 1}
            onClick={(e) => {
              e.preventDefault();
              onApprove(item);
            }}
          >
            Approve
          </MDButton>
          <MDButton
            variant="contained"
            color="error"
            size="small"
            sx={{
              padding: "6px 12px",
              borderRadius: "8px",
              fontWeight: "bold",
              fontSize: "0.8rem",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#c62828",
                transform: "scale(1.05)",
              },
            }}
            disabled={item?.approve == 1 || item.cancel == 1}
            onClick={(e) => {
              e.preventDefault();
              onCancel(item);
            }}
          >
            Cancel
          </MDButton>
        </MDBox>
      ),
    })),
  };
}
